"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appSettingsStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class AppSettingsStore {
    constructor() {
        this.agLicense = "";
        this.submitted = false;
        this.submission = {};
        this.readErx = async (erxString) => {
            const result = await api_1.AppSettingsEndpoint.erxTranslate.apiCall({ query: { erxString } });
            return result.output;
        };
        this.upload = async (files, settingId, uploadType) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file); // Why is name gone?
            });
            formData.append("settingId", settingId);
            formData.append("uploadType", uploadType);
            const response = await api_1.AppSettingsEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                console.log("error in uploading logo:", response);
                this.submission = { error: response.code, value: this.submission.value };
                alert(this.submission.error);
            }
            else {
                console.log("successfully uploaded logo");
                this.submission = { value: this.submission.value };
                this.submitted = true;
            }
        };
        this.deleteUpload = async (uploadId, settingId) => {
            const result = await api_1.AppSettingsEndpoint.removeFile.apiCall(null, { id: uploadId, settingId });
            if (api_1.isError(result)) {
                console.log("Error in deleting billing logo.", result);
            }
            else {
                console.log("Successfully deleted billing logo.");
            }
        };
        this.getTextareaSize = async () => {
            const result = await api_1.AppSettingsEndpoint.getTextareaSize.apiCall();
            if (api_1.isError(result)) {
                // this.upload = {
                //   error: result.code,
                //   value: this.uploads.value,
                // };
                console.log("Error in getting textarea size.");
                return null;
            }
            else {
                // await usersListStore.loadUsers();
                console.log("Successfully loaded textarea size.");
                return result.results;
            }
        };
        this.generatePdf = async (startDate, endDate, siteId) => {
            const result = await api_1.AppSettingsEndpoint.generatepdf.apiCall(null, {
                startDate,
                endDate,
                siteId
            });
            // return !!result ? result : null;
            if (api_1.isError(result)) {
                // this.upload = {
                //   error: result.code,
                //   value: this.uploads.value,
                // };
                console.log("Error in generating pdf.", result.code);
                return null;
            }
            console.log("Successfully generated pdf.");
            console.log("result from genratepdf endpoint:", result);
            console.log("result.pdfFilePath from genratepdf:", result.pdfFilePath);
            console.log("type of result.pdfFilePath:", typeof result.pdfFilePath);
            // const pdf = window.pdfMake.createPdf(result.pdf);
            // if (!!pdf) pdf.open();
            try {
                console.log("inside try for window.open in app setting store");
                window.open(result.pdfFilePath);
            }
            catch (e) {
                console.log("error in window.open in app-settings-store:", e.message);
            }
            return result.pdfFilePath;
        };
        this.readLicense = async (vendor) => {
            const query = { query: { vendorName: vendor } };
            const endPoint = api_1.AppSettingsEndpoint.readLicense;
            const result = await endPoint.apiCall(query);
            api_1.isError(result)
                ? { code: result.code, success: false }
                : (this.agLicense = result.license.License);
        };
        this.readClaimData = async (siteId, rxId) => {
            const endPoint = api_1.AppSettingsEndpoint.readClaimData;
            const result = await endPoint.apiCall(null, { siteId, rxId });
            return api_1.isError(result) ? { code: result.code } : result.result;
        };
        //E-096 B-049.611
        this.readStuckClaimData = async (siteId) => {
            const endPoint = api_1.AppSettingsEndpoint.readStuckClaimData;
            const result = await endPoint.apiCall(null, { siteId });
            return api_1.isError(result) ? { code: result.code } : result.result;
        };
        //E-096 B-049.611
        this.updateStuckedClaimData = async (claimData) => {
            const endPoint = api_1.AppSettingsEndpoint.updateStcukedClaimData;
            const result = await endPoint.apiCall(null, { claimData });
            return api_1.isError(result) ? { code: result.code } : { success: true };
        };
        this.updateClaimData = async (claimData) => {
            const endPoint = api_1.AppSettingsEndpoint.updateClaimData;
            const result = await endPoint.apiCall(null, { claimData });
            // return isError(result) ? { code: result.code } : { success: true };
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.readCopayBlacklist = async () => {
            const endPoint = api_1.AppSettingsEndpoint.readCopayBlacklist;
            const result = await endPoint.apiCall();
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.updateCopayBlacklist = async (blacklistData) => {
            console.log({ blacklistData });
            const endPoint = api_1.AppSettingsEndpoint.updateCopayBlacklist;
            const result = await endPoint.apiCall(null, { blacklistData });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        // New API E-059
        this.allReadCopayBlacklist = async () => {
            const endPoint = api_1.AppSettingsEndpoint.allReadCopayBlacklist;
            const result = await endPoint.apiCall();
            return api_1.isError(result) ? { code: result.code } : { data: result.result };
        };
        //create new Api for NDC tables E-059
        this.readNdcBlacklist = async () => {
            const endPoint = api_1.AppSettingsEndpoint.readNdcBlacklist;
            const result = await endPoint.apiCall();
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        //New API E-059
        this.allReadNdcBlacklist = async () => {
            const endPoint = api_1.AppSettingsEndpoint.allReadNdcBlacklist;
            const result = await endPoint.apiCall();
            return api_1.isError(result) ? { code: result.code } : { data: result.result };
        };
        //E-059 new API for NDC blacklist
        this.updateNdcBlacklist = async (blacklistData) => {
            // console.log({blacklistData});
            const endPoint = api_1.AppSettingsEndpoint.updateNdcBlacklist;
            const result = await endPoint.apiCall(null, { blacklistData });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        //E-080
        this.updateConnectAssetCategory = async (connectAssestData) => {
            const endPoint = api_1.AppSettingsEndpoint.updateConnectAssetCategory;
            const result = await endPoint.apiCall(null, { connectAssestData });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.readCancellations = async () => {
            const endPoint = api_1.AppSettingsEndpoint.readCancellations;
            const result = await endPoint.apiCall();
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.updateCancellations = async (cancellations) => {
            const endPoint = api_1.AppSettingsEndpoint.updateCancellations;
            const result = await endPoint.apiCall(null, { cancellations });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.deleteCancellations = async (id) => {
            const endPoint = api_1.AppSettingsEndpoint.deleteCancellations;
            const result = await endPoint.apiCall(null, { id });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
        this.createCancellations = async (cancellation) => {
            const endPoint = api_1.AppSettingsEndpoint.createCancellations;
            const result = await endPoint.apiCall(null, { cancellation });
            return api_1.isError(result) ? { code: result.code } : { data: result.data };
        };
    }
    /**
     * @param settingName
     * @param frontEnd Optional: needs to be true in order read values from devOnly settings in the front end
     */
    async readSettings(settingName, frontEnd) {
        const query = { query: { settingName, frontEnd } };
        const result = await api_1.AppSettingsEndpoint.readSettings.apiCall(query);
        // return !!result ? result : null;
        if (api_1.isError(result)) {
            return null;
        }
        else {
            return result.results;
        }
    }
    async updateSettings(settings) {
        const result = await api_1.AppSettingsEndpoint.updateSettings.apiCall(null, {
            settings
        });
        return !!result ? result : null;
    }
    async createRejection(rejection) {
        const result = await api_1.AppSettingsEndpoint.createRejection.apiCall(null, rejection);
        return !!result ? result : null;
    }
    async deleteRejection(rejection) {
        const result = await api_1.AppSettingsEndpoint.deleteRejection.apiCall(null, rejection);
        return !!result ? result : null;
    }
    async callTrigger(setting) {
        const result = await api_1.AppSettingsEndpoint.callTrigger.apiCall(null, setting);
        return !!result ? result : { success: false };
    }
    async getLoadAlertsCount() {
        const result = await api_1.AppSettingsEndpoint.getLoadAlertsCount.apiCall();
        if (api_1.isError(result)) {
            return null;
        }
        return result.results.value;
    }
    async readConnectAsset(entityType) {
        const query = { query: { entityType } };
        const result = await api_1.AppSettingsEndpoint.readConnectAsset.apiCall(query);
        if (api_1.isError(result)) {
            return null;
        }
        return result.results;
    }
    async createConnectAssetCategory(connectAssetCategory) {
        const result = await api_1.AppSettingsEndpoint.createConnectAssetCategory.apiCall(null, connectAssetCategory);
        return !!result ? result : null;
    }
    async deleteConnectAssetCategory(connectAssetCategory) {
        const result = await api_1.AppSettingsEndpoint.deleteConnectAssetCategory.apiCall(null, connectAssetCategory);
        if (api_1.isError(result)) {
            console.log("error in delete connectAsset category", result);
            return null;
        }
        return result;
    }
    async loadBillingLogo() {
        const result = await api_1.AppSettingsEndpoint.loadBillingLogo.apiCall();
        if (api_1.isError(result)) {
            console.log("error in loading billing logo", result);
            return null;
        }
        return result.result;
    }
}
__decorate([
    mobx_1.observable
], AppSettingsStore.prototype, "agLicense", void 0);
__decorate([
    mobx_1.observable
], AppSettingsStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], AppSettingsStore.prototype, "submission", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readSettings", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readErx", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateSettings", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "createRejection", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "deleteRejection", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "callTrigger", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "getLoadAlertsCount", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readConnectAsset", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "createConnectAssetCategory", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "deleteConnectAssetCategory", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "loadBillingLogo", null);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "upload", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "deleteUpload", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "getTextareaSize", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "generatePdf", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readLicense", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readClaimData", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readStuckClaimData", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateStuckedClaimData", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateClaimData", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readCopayBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateCopayBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "allReadCopayBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readNdcBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "allReadNdcBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateNdcBlacklist", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateConnectAssetCategory", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "readCancellations", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "updateCancellations", void 0);
__decorate([
    mobx_1.action
], AppSettingsStore.prototype, "createCancellations", void 0);
exports.appSettingsStore = new AppSettingsStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/store.ts
// module id = 105
// module chunks = 0